<template>
  <div class="login">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm">
      <el-form-item label="账号：" prop="acc_num">
        <el-input type="text" v-model="ruleForm.acc_num" style="width: 300px;"></el-input>
      </el-form-item>
      <el-form-item label="密码：" prop="pawd">
        <el-input type="password" v-model="ruleForm.pawd" style="width: 300px;"></el-input>
      </el-form-item>
      <el-form-item style="text-align: center;">
        <el-button style="width: 300px;" type="primary" @click="submitForm('ruleForm')" :loading="isLogin">{{isLogin ? '登录中' : '登录'}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'login',
    metaInfo () {
      return {
        title:'F F 的 Blog'
      }
    },
    data () {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'))
        } else {
          callback()
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else {
          callback()
        }
      };
      return {
        isLogin: false,
        ruleForm: {
          acc_num: '',
          pawd: ''
        },
        rules: {
          acc_num: [
            { validator: validatePass, trigger: 'blur' }
          ],
          pawd: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      }
    },

    mounted () {
      
    },

    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http.post('user/login', this.ruleForm, true).then(res => {
              if(res.data.code == 0){
                sessionStorage.setItem('userInfo', JSON.stringify(res.data.obj))
                this.$router.replace('/ffadmin')
              } else {
                this.$message.warning(res.data.msg)
              }
            }).catch(err => {
              this.$message.error('网络有误！')
            })
          } else {
            this.$message.warning('请输入账号和密码！')
            return false
          }
        })
      }
    }
  }
</script>

<style>
  .login {
    margin: 50px 0;
    padding: 50px 0;
    background-color: #ffffff;
    box-shadow: 0px 0px 5px 0px #999;
    border-radius: 30px;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue